// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2019-01-17 14:11:43 +0100 (Thu, 17 Jan 2019) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 98231 $
//  Purpose   : templating package
// =============================================================================
export {sagas} from './sagas'

import * as reducers from './reducers'
export {reducers}

import * as actions from './actions'
export {actions}

// utility functions
export {runFilters, decodeGo} from './sagas'

// do not touch react components here
// export {View} from './view'
// import * as parts from './parts'
export const parts = true
